export default __webpack_public_path__ + "static/media/locations.16ebe1c9.svg";